import { mdiCloseCircle, mdiPaperclip, mdiShapeSquarePlus } from '@mdi/js';
import React, { useState } from 'react';
import { formatBytes } from '../../services';
import * as S from './attachment-button.styles';

export interface IAttachmentButtonProps {
    className?: string;
    filename: string;
    filesize?: number;
    thumbnail?: string;
    onDownload?: () => Promise<void>;
    onRemove?: () => void;
    onAssign?: () => void;
}
export const AttachmentButton: React.FunctionComponent<IAttachmentButtonProps> = (
    props: IAttachmentButtonProps,
): React.ReactElement => {
    const { className, filename, filesize, thumbnail, onDownload, onRemove, onAssign } = props;

    const [isDownloading, setIsDownloading] = useState(false);
    const [isAssigning, setIsAssigning] = useState(false);
    const [isAssigned, setIsAssigned] = useState(false);
    const [isRemoving, setIsRemoving] = useState(false);

    const handleDownload = async (): Promise<void> => {
        setIsDownloading(true);
        await (onDownload && onDownload());
        setIsDownloading(false);
    };

    const handleAssign = async (e: React.MouseEvent): Promise<void> => {
        e.stopPropagation();
        setIsAssigning(true);
        await (onAssign && onAssign());
        setIsAssigning(false);
        setIsAssigned(true);
    };

    const handleRemove = async (e: React.MouseEvent): Promise<void> => {
        e.stopPropagation();
        setIsRemoving(true);
        await (onRemove && onRemove());
        setIsRemoving(false);
    };

    const renderImage = () => {
        return (
            <S.AttachmentImage title={filename}>
                <S.AttachmentThumbnail src={thumbnail} alt={filename} onClick={handleDownload} />
                {onAssign && !isAssigned && (
                    <S.StyledTooltip direction="top" variant="dark" title={<span>Assign document to the claim</span>}>
                        <S.IconButton onClick={handleAssign} disabled={isAssigning} variant="text">
                            <S.CloseIcon path={mdiShapeSquarePlus} size={0.75} />
                        </S.IconButton>
                    </S.StyledTooltip>
                )}
                {onRemove && (
                    <S.IconButton onClick={handleRemove} variant="text" disabled={isRemoving}>
                        <S.CloseIcon path={mdiCloseCircle} size={0.75} />
                    </S.IconButton>
                )}
                {isDownloading && <S.DownloadSpinner size="18px" />}
            </S.AttachmentImage>
        );
    };
    const renderButton = () => {
        return (
            <S.AttachmentButton className={className} onClick={handleDownload}>
                <S.PaperclipIcon path={mdiPaperclip} size={0.75} />
                <S.AttachmentLabels>
                    <S.AttachmentFilename>{filename}</S.AttachmentFilename>
                    <S.AttachmentSize>{formatBytes(filesize)}</S.AttachmentSize>
                </S.AttachmentLabels>
                {onAssign && !isAssigned && (
                    <S.StyledTooltip direction="top" variant="dark" title={<span>Assign document to the claim</span>}>
                        <S.IconButton onClick={handleAssign} disabled={isAssigning} variant="text">
                            <S.CloseIcon path={mdiShapeSquarePlus} size={0.75} />
                        </S.IconButton>
                    </S.StyledTooltip>
                )}
                {onRemove && (
                    <S.IconButton onClick={handleRemove} variant="text" disabled={isRemoving}>
                        <S.CloseIcon path={mdiCloseCircle} size={0.75} />
                    </S.IconButton>
                )}
                {isDownloading && <S.DownloadSpinner size="18px" />}
            </S.AttachmentButton>
        );
    };

    return thumbnail ? renderImage() : renderButton();
};
